import { HackleApp } from "../HackleWebAppClient"
import { HackleAppInvocationProcessor } from "./HackleAppInvocationProcessor"
import { InvocationChannel, resolveInvocationChannels } from "./InvocationChannel"
import { BridgeResponseDispatcher, installHackleBridge } from "./BridgeResponseDispatcher"
import { FunctionAppInvocator, MessageAppInvocator, PromptAppInvocator } from "./HackleAppInvocator"
import InvocationResponseResolver from "./InvocationResponseResolver"

export function createInvocationProcessor(hackleApp: HackleApp): HackleAppInvocationProcessor {
  const channels = resolveInvocationChannels(hackleApp)
  const responseResolver = new InvocationResponseResolver()

  let promptInvocator: PromptAppInvocator | null = null
  let functionInvocator: FunctionAppInvocator | null = null
  let messageInvocator: MessageAppInvocator | null = null

  for (const channel of channels) {
    switch (channel) {
      case InvocationChannel.prompt:
        promptInvocator = new PromptAppInvocator(responseResolver)
        break
      case InvocationChannel.function:
        functionInvocator = new FunctionAppInvocator(responseResolver)
        break
      case InvocationChannel.message:
        messageInvocator = MessageAppInvocator.createOrNull(hackleApp, new BridgeResponseDispatcher(responseResolver))
        if (messageInvocator !== null) {
          installHackleBridge(window)
        }
        break
    }
  }

  const syncInvocator = promptInvocator ?? functionInvocator
  if (syncInvocator === null) {
    throw new Error(
      `No sync invocation channel available. [channels=${channels}, invocationType=${hackleApp.getInvocationType()}]`
    )
  }

  const asyncInvocator = messageInvocator ?? syncInvocator

  return new HackleAppInvocationProcessor(syncInvocator, asyncInvocator)
}
